import { correctionAutoApplies, letterAutoApproves } from '@attendance/shared';
import { useAuthStore } from '../stores/authStore.js';
import { useFeatureEnabled } from '../stores/brandingStore.js';
import { heldPermissions } from './usePermission.js';

/* The server's own rule (`@attendance/shared` autoApply.ts), read from the
   signed-in user. A screen that re-derived it — `role === 'ADMIN'` — hid
   "My requests" from an admin and left it for HR, whose requests apply at once
   too. */

function held(user: Parameters<typeof heldPermissions>[0]): { has(k: string): boolean } {
  const keys = new Set(heldPermissions(user) ?? []);
  return { has: (k) => keys.has(k) };
}

/** This person's own corrections apply the moment they are filed. */
export function useCorrectionAutoApplies(): boolean {
  return useAuthStore((s) => correctionAutoApplies(s.user?.role, held(s.user)));
}

/** This person's own letter requests are issued the moment they are filed. */
export function useLetterAutoApproves(): boolean {
  return useAuthStore((s) => letterAutoApproves(held(s.user)));
}

/** This person may list and close past days missing a check-out — the bulk save's rule. */
export function useCanCloseMissedCheckouts(): boolean {
  const applies = useCorrectionAutoApplies();
  return useFeatureEnabled('corrections') && applies;
}
